import React, { Component } from 'react';
import { Link } from "react-router-dom";

class OrdasofnList extends Component {
	render() {
		var els = [];
		if (window.ordabankiData && window.ordabankiData['dictionaries']) {
			let index = 0;
			for (let dictionary in window.ordabankiData.dictionaries) {
				els.push(<span key={index} className="nav-item"><Link className="nav-link" to={'/leit//ordabok/'+dictionary}>{window.ordabankiData.dictionaries[dictionary]}</Link></span>);
				index++;
			}
		}

		return (
			<div className={this.props.className || 'nav nav-pills'}>
				{els}
			</div>
		);
	}
}

export default OrdasofnList;



// WEBPACK FOOTER //
// ./src/components/OrdasofnList.js